import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[indeterminate]',
    standalone: false
})
export class IndeterminateDirective {
  @Input()
  set indeterminate(value) {
    this.elem.nativeElement.indeterminate = value;
  }
  constructor(private elem: ElementRef) {}
}
